import { TractorFieldNames } from '@contracts/order/fields/TractorInformationFields';
import { State } from '@contracts/order/valueNormalizers/State';
import {
  BooleanField,
  DropdownField,
  EmailField,
  StringField,
} from '@src/permitField/PermitFields';
import type { StringSchema } from 'yup';
import * as yup from 'yup';

export class TractorIsLeasedField extends BooleanField {
  public static fieldName: string = TractorFieldNames.TractorIsLeased;
}

export class TractorOwnerNameField extends StringField {
  public static fieldName: string = TractorFieldNames.TractorOwnerName;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class OwnerCompanyNameField extends StringField {
  public static fieldName: string = TractorFieldNames.OwnerCompanyName;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class USDOTNumberOfOwningCompanyField extends StringField {
  public static fieldName: string =
    TractorFieldNames.USDOTNumberOfOwningCompany;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class OwnerAddressField extends StringField {
  public static fieldName: string = TractorFieldNames.OwnerAddress;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class OwnerCityField extends StringField {
  public static fieldName: string = TractorFieldNames.OwnerCity;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class OwnerStateField extends DropdownField {
  public static fieldName: string = TractorFieldNames.OwnerState;
  public static options = Object.values(State);
  public static validator = yup.string().when(TractorIsLeasedField.fieldName, {
    is: true,
    then: (schema) => schema.oneOf(OwnerStateField.options).required(),
  });
}

export class OwnerZipCodeField extends StringField {
  public static fieldName: string = TractorFieldNames.OwnerZipCode;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class OwnerPhoneField extends StringField {
  public static fieldName: string = TractorFieldNames.OwnerPhone;
  public static validator: StringSchema = yup
    .string()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class OwnerEmailField extends EmailField {
  public static fieldName: string = TractorFieldNames.OwnerEmail;
  public static validator: StringSchema = yup
    .string()
    .email()
    .when(TractorIsLeasedField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export const tractorOwnerFields = {
  [TractorIsLeasedField.fieldName]: TractorIsLeasedField.validator,
  [TractorOwnerNameField.fieldName]: TractorOwnerNameField.validator,
  [OwnerCompanyNameField.fieldName]: OwnerCompanyNameField.validator,
  [USDOTNumberOfOwningCompanyField.fieldName]:
    USDOTNumberOfOwningCompanyField.validator,
  [OwnerAddressField.fieldName]: OwnerAddressField.validator,
  [OwnerCityField.fieldName]: OwnerCityField.validator,
  [OwnerStateField.fieldName]: OwnerStateField.validator,
  [OwnerZipCodeField.fieldName]: OwnerZipCodeField.validator,
  [OwnerPhoneField.fieldName]: OwnerPhoneField.validator,
  [OwnerEmailField.fieldName]: OwnerEmailField.validator,
};
